module.exports = __webpack_public_path__ + "img/isracard-large.393b5ea0.svg";